import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DailyBonusLocker').create(() => ({
  root: {
    marginTop: '24px',
    position: 'relative',
    width: '100%',
    height: '12px',
    background: 'linear-gradient( #4E4F55 0%, #252525 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid rgba(255, 255, 255, 0.25)',
    borderBottom: '1px solid black',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 1) 0px 1px 0px 0px rgba(255, 255, 255, 0.25) inset',
  },

  lockIcon: {
    position: 'absolute',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 1), 0px 1px 0px 0px rgba(255, 255, 255, 0.25) inset',
    width: '40px',
    background: 'linear-gradient( #4E4F55 0%, #252525 100%)',
    borderRadius: '100%',
    aspectRatio: '1/1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
}))
